import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Server-verified admin gate. Reuses the /admin session cookie (HttpOnly,
// Secure, SameSite=strict) — nothing a visitor can set client-side.
// While the probe is in flight we render nothing (no flash of content).
// On failure we fall through to the same /the-mission destination that
// unauthenticated visitors already receive.
export default function AdminGate({ children, fallback = "/the-mission" }) {
  const [state, setState] = useState("checking"); // "checking" | "ok" | "deny"
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/admin/me`, { withCredentials: true })
      .then(() => {
        if (!cancelled) setState("ok");
      })
      .catch(() => {
        if (!cancelled) setState("deny");
      });
    return () => {
      cancelled = true;
    };
  }, []);
  if (state === "checking") return null;
  if (state === "deny") return <Navigate to={fallback} replace />;
  return children;
}
